import { BookWidgetFields } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { PriceTypes } from '../../constants/postData.constants';
import { Redirect_search_routes } from '../../constants/urls.constants';
import {
  PostDataSearchLocalStorage,
  PostDataSearchState
} from '../../models/postData-search-local-storage.interface';
import { retrievePostDataInitialState } from './postData-initial-values.adaptor';
import { getSegmentForTripType } from './postData-segments.adaptor';
import {
  getBestFareValue,
  getIncludeBasicFaresUnchecked,
  getMeetingEventCode,
  getPriceType,
  getRefundableFareField,
  getShopType,
  isFlexibleAirport,
  isFlexibleDates
} from './postData-utils.adaptor';

export const preparePostDataValuesOnFindFlights = (
  cacheKeySuffix: string,
  bookWidgetFields: BookWidgetFields
): PostDataSearchState => {
  const flexibleAirport = isFlexibleAirport(bookWidgetFields);
  const flexibleDates = isFlexibleDates(bookWidgetFields);
  const priceType = getPriceType(bookWidgetFields.shopMilesField);
  const bestFare = getBestFareValue(bookWidgetFields);
  const meetingEventCode = getMeetingEventCode(bookWidgetFields);
  const refundableFare = getRefundableFareField(bookWidgetFields);
  const shopType = getShopType(bookWidgetFields.shopMilesField);
  const includeBasicFaresUnchecked = getIncludeBasicFaresUnchecked(
    bookWidgetFields.basicFaresField
  );

  const postDataSearch: PostDataSearchLocalStorage = {
    ...retrievePostDataInitialState(),
    awardTravel: (priceType === PriceTypes.AWARD).toString(),
    bestFare,
    cacheKey: cacheKeySuffix,
    currentSolution: { sliceIndex: 0, solutionId: '' },
    datesFlexible: flexibleDates,
    flexAirport: flexibleAirport,
    flexDate: flexibleDates,
    initialSearchBy: {
      ...retrievePostDataInitialState().initialSearchBy,
      fareFamily: bestFare,
      meetingEventCode,
      refundable: refundableFare,
      flexAirport: flexibleAirport,
      flexDate: flexibleDates
    },
    // priceSchedule: priceType.toUpperCase(),
    meetingEventCode,
    passengers: [
      { count: bookWidgetFields.passengerField.selectedPaxValue, type: 'ADT' }
    ],
    priceType,
    refundableFlightsOnly: refundableFare,
    segments: getSegmentForTripType(bookWidgetFields),
    shopType,
    tripType: bookWidgetFields.tripTypesField.selectedTripType,
    includeBasicFaresUnchecked
  };

  return {
    redirectionPage: getRedirectionPage(flexibleAirport, flexibleDates),
    postDataSearch
  };
};

const getRedirectionPage = (
  isFlexibleAirport: boolean,
  isFlexibleDates: boolean
) => {
  if (isFlexibleAirport) return Redirect_search_routes.FLEXIBLE_AIRPORTS;
  else if (isFlexibleDates) return Redirect_search_routes.FLEXIBLE_DATES;
  else return Redirect_search_routes.SEARCH_RESULTS;
};
